// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown__VwLRx","dropdownFocus":"dropdownFocus__2KIc-"};